/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/TextArea/theme';

export const TextAreaTheme = theme;
